/* src/requests/scene.js */

import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import { Paper, Grid, Typography } from '@material-ui/core';

import HeaderTable from '../../app/components/HeaderTable';
import SimpleSelect from '../../app/components/Select';
import LocationModal from '../locations/cards/AddLocationCard';
import CourseModal from '../courses/components/AddCourse';
import LanguageModal from './components/LanguagePopup';

import CourseRequestsCard from './cards/CourseRequestsCard';

class RequestScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: '',
      locationOpen: false,
      languageOpen: false,
      courseOpen: false,
    };
    this.onSelect = this.onSelect.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.onClose = this.onClose.bind(this);
  }

  componentDidMount() {

  }

  onSelect(value) {
    this.setState({ selected: value });
  }

  onClose(type) {
    switch (type) {
      case 'LOCATION':
        this.setState({ locationOpen: false });
        break;
      case 'COURSE':
        this.setState({ courseOpen: false });
        break;
      case 'LANGUAGE':
        this.setState({ languageOpen: false });
        break;
      default:
    }
  }

  onRowClick(rowData) {
    switch (rowData.type) {
      case 'Location':
        this.setState({ locationOpen: true });
        break;
      case 'Course':
        this.setState({ courseOpen: true });
        break;
      case 'Language':
        this.setState({ languageOpen: true });
        break;
      default:
    }
  }

  renderPopups() {
    const { locationOpen, languageOpen, courseOpen } = this.state;

    return (
      <React.Fragment>
        <LocationModal
          open={locationOpen}
          mode="add"
          onClose={() => this.onClose('LOCATION')}
        />
        <CourseModal
          open={courseOpen}
          mode="add"
          onClose={() => this.onClose('COURSE')}
        />
        <LanguageModal
          open={languageOpen}
          mode="add"
          onClose={() => this.onClose('LANGUAGE')}
        />
      </React.Fragment>
    );
  }

  render() {
    const { classes } = this.props;
    return (
      <CourseRequestsCard />
    );
    //
    // return (
    //   <Paper>
    //     <Grid container justify="space-between" alignItems="center">
    //       <Typography
    //         className={classes.header}
    //         color="primary"
    //       >
    //         Requests
    //       </Typography>
    //       <SimpleSelect
    //         className={classes.select}
    //         dataArray={selectData}
    //         withDefault
    //         onValueChange={this.onSelect}
    //       />
    //     </Grid>
    //     <HeaderTable data={data} hover onRowClick={this.onRowClick} />
    //     {this.renderPopups()}
    //   </Paper>
    // );
  }
}

const styles = theme => ({
  select: {
    padding: theme.spacing.unit * 3,
  },
  header: {
    fontSize: 20,
    padding: theme.spacing.unit * 3,
  },
});

RequestScreen.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RequestScreen);



// WEBPACK FOOTER //
// ./src/modules/requests/Scene.js